import React from 'react';
import './LabelSelectBox.scss';
import SelectOptionSearch from "../../UI/SelectOptionSearch";

function LabelSelectBox(props) {
    return (
        <div className={`label-select-box ${props.className}`}>

            <label>{props.labelText}</label>
            <SelectOptionSearch
                defaultValue={props.defaultValue}
                options={props.options}
                onSelect={props.onSelect}
                classNameInput={"input-class"}
                spanWidth={'170px'}
                emptyInputAfterSubmit={props.emptyInputAfterSubmit}
            />

        </div>
    );
}

export default LabelSelectBox;